<script lang="ts">
	import { checkoutSession } from '$lib/state/checkoutSession.svelte';
	import Blok from '$lib/storyblok/blok.svelte';
	import type { StripeProductData } from '$lib/storyblok/types';
	import type { ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			use_as_default: boolean;
			stripe_product: StripeProductData;
			body: ISbStoryData['content'][];
		}>['content'];
	}

	const { content }: Props = $props();
</script>

{#if (content.use_as_default && checkoutSession.selectedLookupKey === undefined) || checkoutSession.selectedLookupKey === content.stripe_product?.priceLookupKey || checkoutSession.selectedBaseStripeProduct?.priceLookupKey === content.stripe_product?.priceLookupKey}
	{#each content.body as blok}
		<Blok content={blok} />
	{/each}
{/if}
